export const ENDPOINT_CONSTANTS = {
  INSTITUTION_REGISTER: '/institution',
  LOGIN: '/auth/login',
  ME: '/auth/me',
  INSTITUTION_CANDIDATE: '/institution/candidate',
  INSTITUTION_DASHBOARD: '/institution/dashboard',
  INSTITUTION_DEPARTMENT: '/institution/dashboard/department',
  INSITITUTION_CANDIDATE_REGISTER_NUMBER:
    '/institution/candidate/register-number',
  INSTITUTION_CANDIDATE_BULK: '/institution/candidate/bulk',
  ROLE: '/role',
  CANDIDATE_PROFILE: '/auth/profile/candidate',
  INSTITUTION_PROFILE: '/auth/profile/institution',
  RECRUITER_PROFILE: '/auth/profile/recruiter',
  PROFILE_IMAGE: '/auth/profile/image',
  QUIZZES_TOPICS: '/topic',
  START_QUIZ: '/quiz/start',
  QUIZ: '/quiz',
  SUBMIT_QUESTION_ANSWER: '/quiz/answer',
  SUBMIT_QUIZ: '/quiz/answer/submit',
  END_QUIZ: '/quiz/end',
  UPLOAD: '/upload/single',
  VERIFICATION_LINK: '/auth//resent/link',
  INSTITUTION_CANDIDATE_SELF: '/institution/candidate/self',
  RECRUITER_REGISTER: '/recruiter',
  CANDIDATE_PROGRESS: '/candidate',
  SKILLS: '/role/skills',
  JOB_POST: '/job',
  INTERNSHIP_POST: '/job/internship/posts',
  CREATE_INTERNSHIP: '/job/internship',
  CLOSE_JOB_POST: '/job/status/close',
  OPEN_JOB_POST: '/job/status/open',
  RECRUITER_CANDIDATE: '/recruiter/candidate',
  RESET_PASSWORD: '/auth/reset/password',
  RECRUITER_DASH_STATS: '/recruiter/dashboard/stats',
  RECRUITER_DASH_INTERVIEW: '/recruiter/dashboard/interview',
  FORGOT_PASSWORD_MAIL: '/auth/forgot/password',
  RESET_FORGOT_PASSWORD: '/auth/forgot/reset/password',
  USER_ROLE: '/user-role',
  INVITE_USER: '/auth/invite',
  INVITE_USER_STATUS: '/auth/invite/status',
  RE_INVITE_USER: '/auth/invite/resent',
  MY_INVITATION: '/auth/my-invite'
};
